import { useEffect } from "react";
import Header from "@/pages/home/components/Header";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

const personnel = [
  { nom: "Paul Versteeg-Lytwyn", role: "Directeur général", poste: "Poste 27", courriel: "paulv@mpfcanada.ca" },
  { nom: "Lisa DeWitt", role: "Gestionnaire du traitement des données", poste: "Poste 22", courriel: "lisad@mpfcanada.ca" },
  { nom: "Humberto Martins", role: "Directeur des prestations de retraite", poste: "Poste 23", courriel: "humbert@mpfcanada.ca" },
  { nom: "Nadia Chamale", role: "Traitement des contrats", poste: "Poste 30", courriel: "nadia@mpfcanada.ca" },
  { nom: "Preesin Doorganah", role: "Adjoint, prestations de retraite", poste: "Poste 29", courriel: "benefits@mpfcanada.ca" },
  { nom: "Thinn Soe", role: "Adjointe au directeur général", poste: "Poste 28", courriel: "thinn@mpfcanada.ca" },
  { nom: "Wahida Hashem", role: "Réceptionniste", poste: "Poste 21", courriel: "reception@mpfcanada.ca" },
];

interface LigneContactProps {
  icone: string;
  etiquette: string;
  children: React.ReactNode;
}

function LigneContact({ icone, etiquette, children }: LigneContactProps) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#f4f8fc] flex-shrink-0">
        <i className={`${icone} text-[#1a8fc1] text-sm`}></i>
      </div>
      <div className="min-w-0">
        <h3 className="text-xs font-semibold text-[#0d1f4c] mb-0.5 uppercase tracking-wide">
          {etiquette}
        </h3>
        <div className="text-sm text-gray-500 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

interface FichePersonnelProps {
  nom: string;
  role: string;
  poste: string;
  courriel: string;
}

function FichePersonnel({ nom, role, poste, courriel }: FichePersonnelProps) {
  return (
    <div className="bg-[#f8fafc] rounded-lg border border-gray-200 border-t-2 border-t-[#1a8fc1] shadow hover:shadow-md transition-shadow p-4 flex flex-col">
      <h4 className="text-sm font-semibold text-[#0d1f4c] leading-tight mb-1">{nom}</h4>
      <p className="text-xs text-gray-600 mb-3">{role}, {poste}</p>
      <div className="mt-auto">
        <a
          href={`mailto:${courriel}`}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-3 py-1.5 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-mail-line text-xs"></i>
          {courriel}
        </a>
      </div>
    </div>
  );
}

export default function FrContact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <Navbar />

      <main className="flex-1">
        {/* Hero header */}
        <section className="w-full bg-[#0d1f4c] py-10">
          <div className="max-w-[1200px] mx-auto px-6">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-0.5 bg-[#1a8fc1]"></div>
              <span className="text-[#7ec8e3] text-xs font-semibold tracking-widest uppercase">
                Bureau de la Caisse
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-3">
              Nous joindre
            </h1>
            <p className="text-base text-white/70 max-w-[600px]">
              Communiquez avec le Bureau de la Caisse pour toute question concernant votre retraite, les cotisations, les prestations, l&rsquo;accès au compte membre ou des renseignements généraux sur le régime.
            </p>
          </div>
        </section>

        {/* Contact details */}
        <section className="w-full bg-white py-10">
          <div className="max-w-[1200px] mx-auto px-6">
            {/* Main contact details panel */}
            <div className="bg-[#f8fafc] rounded-lg border border-gray-300 border-t-2 border-t-[#1a8fc1] shadow p-5 md:p-6 mb-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
                {/* Left column */}
                <div className="space-y-4">
                  <LigneContact icone="ri-map-pin-line" etiquette="ADRESSE">
                    200 Yorkland Blvd., bureau 605<br />
                    Toronto (Ontario) M2J 5C1
                    <div className="mt-1.5">
                      <a
                        href="https://www.google.com/maps/search/?api=1&query=200%20Yorkland%20Blvd%20Suite%20605%20Toronto%20Ontario%20M2J%205C1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-xs font-semibold text-[#1a8fc1] border border-[#1a8fc1]/40 rounded-lg px-2.5 py-1 hover:bg-[#f4f8fc] hover:border-[#1a8fc1] transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-map-pin-line text-xs"></i>
                        Voir la carte
                      </a>
                    </div>
                  </LigneContact>

                  <LigneContact icone="ri-phone-line" etiquette="TÉLÉPHONE">
                    416-497-4702
                  </LigneContact>

                  <LigneContact icone="ri-printer-line" etiquette="TÉLÉCOPIEUR">
                    416-497-4742
                  </LigneContact>
                </div>

                {/* Right column */}
                <div className="space-y-4">
                  <LigneContact icone="ri-time-line" etiquette="HEURES DE BUREAU">
                    Du lundi au vendredi<br />
                    9 h 00 à 16 h 00
                  </LigneContact>

                  <LigneContact icone="ri-phone-line" etiquette="SANS FRAIS">
                    1-888-462-6666
                  </LigneContact>

                  <LigneContact icone="ri-mail-line" etiquette="COURRIEL">
                    <a
                      href="mailto:info@mpfcanada.ca"
                      className="text-[#1a8fc1] hover:text-[#157ba6] hover:underline transition-colors cursor-pointer break-all"
                    >
                      info@mpfcanada.ca
                    </a>
                  </LigneContact>
                </div>
              </div>
            </div>

            {/* Staff directory */}
            <div className="mb-6">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-5 h-0.5 bg-[#1a8fc1]"></div>
                <h3 className="text-lg font-bold text-[#0d1f4c]">
                  Personnes-ressources du Bureau de la Caisse
                </h3>
              </div>
              <p className="text-sm text-gray-500 leading-relaxed max-w-[500px] mb-4">
                Communiquez directement avec la personne-ressource appropriée du Bureau de la Caisse ci-dessous.
              </p>
            </div>

            {/* Staff cards — row 1 and 2: first 6 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {personnel.slice(0, 6).map((pers) => (
                <FichePersonnel
                  key={pers.courriel}
                  nom={pers.nom}
                  role={pers.role}
                  poste={pers.poste}
                  courriel={pers.courriel}
                />
              ))}
            </div>

            {/* Staff cards — row 3: last 1 centered */}
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-3">
              {personnel.slice(6).map((pers) => (
                <div key={pers.courriel} className="w-full sm:w-[320px]">
                  <FichePersonnel
                    nom={pers.nom}
                    role={pers.role}
                    poste={pers.poste}
                    courriel={pers.courriel}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}